var map = {
	"./Banner_Corvus.png": "69d4",
	"./Banner_Corvus_word.png": "453f",
	"./Banner_Delphinus.png": "9cfc",
	"./Banner_Delphinus_word.png": "b93a",
	"./Banner_Empty.png": "a652",
	"./Banner_Leonos.png": "e9d6",
	"./Banner_Leonos_word.png": "e10b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbd3";